<template>
  <v-navigation-drawer
    v-model="drawer"
    width="400"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3 w-crud-form">
      <template>
        <v-row>
          <v-col cols="12">
            <v-menu
              v-model="menuFrom"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filters.date_from"
                  label="Desde"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.date_from"
                @input="menuFrom = false"
                no-title
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-menu
              v-model="menuUntil"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="filters.date_until"
                  label="Hasta"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filters.date_until"
                @input="menuUntil = false"
                no-title
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn
              block
              height="40"
              dark
              color="red"
              @click="handleClearFilters"
            >
              <v-icon size="16" class="mr-1">far fa-trash-alt</v-icon>
              Quitar filtros
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn dark color="blue" block height="40" @click="handleSearch">
              <v-icon size="16" class="mr-1">fas fa-search</v-icon>
              Filtrar datos
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "vuex";

import ArrayTools from "../../helpers/ArrayTools";

export default {
  name: "Filters",
  data() {
    return {
      menuUntil: false,
      menuFrom: false,
      drawer: false,
      titleForm: null,
      fields_show_all: true,
      fields_show: [],
      filters: {
        date_from: this.$moment()
          .subtract(7, "days")
          .format("YYYY-MM-DD"),
        date_until: this.$moment().format("YYYY-MM-DD"),
      },
    };
  },
  props: ["parentmessage"],
  computed: {
    ...mapState("authentication", ["office_id"]),
    ...mapState("categories", ["categories"]),
    ...mapState("brands", ["brands"]),
    ...mapState("units", ["units"]),
  },
  methods: {
    ...mapActions("cotizaciones", ["getCotizaciones"]),
    showForm(title) {
      this.filters.office_id = this.office_id;
      this.titleForm = title;
      this.drawer = !this.drawer;
    },
    closeForm() {
      this.drawer = false;
    },
    clearData() {
      this.filters.date_from = this.$moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD");
      this.filters.date_until = this.$moment().format("YYYY-MM-DD");
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    async handleClearFilters() {
      this.clearData();
      this.$emit("hanleChangeFilter", this.filters);
      // await this.getCotizaciones(this.filters);
    },
    async handleSearch() {
      this.$emit("hanleChangeFilter", this.filters);
      // await this.getCotizaciones(this.filters);
      this.closeForm();
    },
  },
};
</script>

<style scoped></style>
